import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            company: state => state.general.info,
        }),
        isMarketplace () {
            return !!(this.company && this.company.is_marketplace)
        }
    },
    methods: {
        openDistributorModal () {
            this.$refs['distributor-modal'].show()
        }
    }
}
